import React from 'react';
import * as TagService from 'Services/TagService';

const initalState = { 
        tagGroups : TagService.TagGroupList,
        tagList : TagService.TagsInit,
    }    

const TagsContext = React.createContext(initalState);

function TagsContextProvider({ children }) {
    const [tagList, setTagList] = React.useState(initalState.tagList);
    React.useEffect(() => {
        (async () => {
            const tags = await TagService.getMicroExperienceTags();
            setTagList(tags);
        })();
    }, []);

    return (
        <TagsContext.Provider value={{ tagList, tagGroups : initalState.tagGroups }}>
            {children}
        </TagsContext.Provider>
    )
}

export { TagsContext, TagsContextProvider }